import { Flex, Heading, Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { LastChangedTag } from "../../../../../common/editing/LastChangedTag/LastChangedTag";

interface Props {
  title: string;
  modifiedAt: string;
}

export const EventHeader = ({ title, modifiedAt }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading
        as="h2"
        size="md"
        width="full"
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        mb="2"
      >
        {title || t("New public sourcing event")}
      </Heading>
      <Flex columnGap="1">
        <Tag size="sm" colorScheme="teal" variant="subtle">
          {t("Draft")}
        </Tag>
        <LastChangedTag timestamp={modifiedAt} />
      </Flex>
    </>
  );
};
